import * as React from "react";

const CubeCheck: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={51} height={54} viewBox="0 0 51 54">
            <g fill="none" fillRule="evenodd">
                <path
                    d="M1 18.848C14.713 12.992 21.699 10.043 21.958 10c.441.122 20.811 8.19 20.959 8.455.11.293.11 8.634 0 25.024L22.183 52 1.361 43.84C1.121 27.276 1 18.945 1 18.849c0-.096 6.986 2.68 20.958 8.33l20.959-8.723M21.736 27v25"
                    stroke="#0071ad"
                    strokeWidth={2}
                />
                <g fillRule="nonzero">
                    <path
                        fill="#0071ad"
                        d="M36 0c-8.284 0-15 6.716-15 15 0 8.284 6.716 15 15 15 8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15z"
                    />
                    <path fill="#FFF" d="M36 28c-7.18 0-13-5.82-13-13S28.82 2 36 2s13 5.82 13 13-5.82 13-13 13z" />
                    <path
                        fill="#0071ad"
                        stroke="#0071ad"
                        strokeWidth={0.5}
                        d="M31.611 14.176l.114-.144a1 1 0 011.391-.178l2.912 2.214 4.764-5.306a1 1 0 011.43-.06l.057.054a1 1 0 01.05 1.406l-5.667 6.15a1 1 0 01-1.362.102l-3.53-2.84a1 1 0 01-.159-1.398z"
                    />
                </g>
            </g>
        </svg>
    );
};

export default React.memo(CubeCheck);
